/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { traitSaleContract } from "config";
import useSnackbarError from "hooks/useSnackbarError";
import { useContractWrite, useWaitForTransaction } from "wagmi";
import useSnackbarSuccess from "hooks/useSnackbarSuccess";
import { BigNumber } from "ethers";

const usePurchaseTraits = (
  purchaseData?: {
    amountToSpendFromWallet: number | BigNumber;
    fancyBear: (number | BigNumber)[];
    amountToSpendFromBear: (number | BigNumber)[];
    honeyJars: (number | BigNumber)[];
    amountToSpendFromHoneyJars: (number | BigNumber)[];
    traitTokenIds: (number | BigNumber)[];
    amountPerTrait: (number | BigNumber)[];
  },
  onSuccess?: () => void
): [() => void, boolean | undefined] => {
  const [{ data, loading: isLoading, error: writeError }, purchase] =
    useContractWrite(
      {
        addressOrName: traitSaleContract.address,
        contractInterface: traitSaleContract.interface,
      },
      "purchaseTraits",
      {
        args: [purchaseData],
      }
    );

  const [{ data: waitData, loading: isWaiting, error: waitError }] =
    useWaitForTransaction(data);

  useSnackbarError(writeError);
  useSnackbarError(waitError);
  useSnackbarSuccess(waitData);

  useEffect(() => {
    if (!isWaiting && waitData) {
      onSuccess?.();
    }
  }, [isWaiting, waitData]);

  return [purchase, isLoading || isWaiting];
};

export default usePurchaseTraits;
